<template>
  <div class="evaluationreport">
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native.prevent="enterSearchMember"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
    >
      <el-form-item label="统计时间">
        <el-date-picker
          :editable="false"
          v-model="dataForm.dateTime"
          unlink-panels
          type="datetimerange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          style="width: 100%; margin-right: 23px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          @click.native.prevent="channelOnSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-row>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="统计报表" name="first"></el-tab-pane>
        <!-- <el-tab-pane label="商家统计" name="second"></el-tab-pane> -->
      </el-tabs>
      <el-row v-if="activeName == 'first'">
        <el-table
          border
          :data="tableDataOne"
          highlight-current-row
          style="width: 100%"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            prop="packageName"
            label="服务类别"
            min-width="200"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="订单数量"
            min-width="200"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="total"
            label="订单金额(元)"
            min-width="200"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <ul class="evaluationreport-ul ul-three clearfix">
          <li>
            <div
              id="chartPieOne"
              ref="chartPieOne"
              style="width: 80%; height: 350px;margin-left:10%"
            ></div>
          </li>
          <li>
            <div
              id="chartPieTwo"
              ref="chartPieTwo"
              style="width: 80%; height: 350px;margin-left:10%"
            ></div>
          </li>
        </ul>
      </el-row>
      <el-row v-if="activeName == 'second'">
        <el-table
          :class="{ 'table-second': istrue }"
          border
          :data="tableData"
          highlight-current-row
          style="width: 100%"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            prop="merchantName"
            label="商家名称"
            min-width="200"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="订单数量"
            min-width="200"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="total"
            label="订单金额(元)"
            min-width="200"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <ul class="evaluationreport-ul ul-three clearfix">
          <li>
            <div
              id="chartPieThree"
              ref="chartPieThree"
              style="width: 100%; height: 350px"
            ></div>
          </li>
          <li>
            <div
              id="chartPieFour"
              ref="chartPieFour"
              style="width: 100%; height: 350px"
            ></div>
          </li>
        </ul>
      </el-row>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      dataForm: {
        dateTime: [],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      activeName: "first",
      tableDataOne: [], //服务类别统计数据
      //服务类别统计的数据源
      serviceName: [],
      serviceNumber: [],
      servicePrice: [],
      serviceNumberColor: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#a94442",
        "#3c763d",
        "#a9334c",
      ],
      serviceTotalColor: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#a94442",
        "#3c763d",
        "#a9334c",
      ],
      istrue: false,
      tableData: [], //商家的统计数据
      //商家统计的数据源
      merchantName: [],
      merchantNumber: [],
      merchantPrice: [],
      merchantNumberColor: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#a94442",
        "#3c763d",
        "#a9334c",
      ],
      merchantTotalColor: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#a94442",
        "#3c763d",
        "#a9334c",
      ],
      groupId: "",
    };
  },
  methods: {
    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember() {
      this.drawCharts();
    },

    /* 
      查询
    */
    channelOnSubmit() {
      this.drawCharts();
    },

    /* 
      点击选项卡切换
    */
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(this.activeName);
      this.drawCharts();
    },

    /* 
      查询服务类别的数量和金额
    */
    queryServiceItem() {
      let params = new Object();
      params.groupId = this.groupId;
      if (this.dataForm.dateTime && this.dataForm.dateTime.length > 0) {
        params.startTime = this.dataForm.dateTime[0];
        params.endTime = this.dataForm.dateTime[1];
      }
      console.log(params);
      this.$postJson("omc/serviceOrder/merchantCount", params).then((res) => {
        console.log(res, "查询数据");
        this.tableDataOne = [];
        this.serviceName = [];
        this.serviceNumber = [];
        this.servicePrice = [];
        // this.serviceNumberColor = [];
        // this.serviceTotalColor = [];
        let dataObj = {
          serviceFirstLevelId: "",
          total: 0,
          orderNumber: 0,
          serviceName: "合计",
        };
        res.result.forEach((item) => {
          if (item.packageName) {
            this.serviceName.push(item.packageName);
            let NumberObj = {};
            let totalObj = {};
            NumberObj.value = item.orderNumber;
            NumberObj.name = item.packageName;
            totalObj.value = item.total;
            totalObj.name = item.packageName;
            this.serviceNumber.push(NumberObj);
            this.servicePrice.push(totalObj);
            dataObj.total += item.total * 1;
            dataObj.orderNumber += item.orderNumber * 1;
            this.tableDataOne.push(item);
          }
        });
        dataObj.packageName = "累计";
        this.tableDataOne.push(dataObj);
        console.log(this.tableDataOne)
        this.drawPieOneChart();
        this.drawPieTwoChart();
      });
    },

    /* 
      查询所有商家的数据
    */
    queryAllMearchat() {
      let params = new Object();
      params.groupId = this.groupId;
      if (this.dataForm.dateTime && this.dataForm.dateTime.length > 0) {
        params.startTime = this.dataForm.dateTime[0];
        params.endTime = this.dataForm.dateTime[1];
      }
      this.$postJson("omc/serviceOrder/merchantCount", params).then((res) => {
        this.tableData = [];
        this.merchantName = [];
        this.merchantNumber = [];
        this.merchantPrice = [];
        let dataObj = {
          merchantId: "",
          total: 0,
          orderNumber: 0,
          merchantName: "合计",
        };
        res.result.forEach((item) => {
          if (item.merchantName) {
            this.merchantName.push(item.merchantName);
            let NumberObj = {};
            let totalObj = {};
            NumberObj.value = item.orderNumber;
            NumberObj.name = item.merchantName;
            totalObj.value = item.total;
            totalObj.name = item.merchantName;
            this.merchantNumber.push(NumberObj);
            this.merchantPrice.push(totalObj);
            dataObj.total += item.total * 1;
            dataObj.orderNumber += item.orderNumber * 1;
            this.tableData.push(item);
          }
        });
        this.tableData.push(dataObj);
        this.drawPieThreeChart();
        this.drawPieFourChart();
        if (this.tableData.length > 8) {
          this.istrue = true;
        } else {
          this.istrue = false;
        }
      });
    },

    /* -------------------------统计报表的echert图----------------------- */
    /* 
      数量占比
    */
    drawPieOneChart() {
      var myChartPie = this.$refs.chartPieOne;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        chartPie.setOption({
          title: {
            text: "数量占比",
            subtext: "",
            x: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          color: this.serviceNumberColor,
          legend: {
            // orient: "vertical",
            // top:"bottom",
            bottom: 0,
            left: "center",
            data: this.serviceName,
          },
          series: [
            {
              name: "数量占比分析",
              type: "pie",
              radius: "80%",
              center: ["50%", "50%"],
              clickable: false, //是否开启点击
              minAngle: 20, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true, //是否启用防止标签重叠策略
              hoverAnimation: true, //是否开启 hover 在扇区上的放大动画效果。
              silent: false, //图形是否不响应和触发鼠标事件
              data: this.serviceNumber, //数据源
              label: {
                normal: {
                  formatter: "{b}",
                  textStyle: {
                    fontSize: 12,
                    // color: "#fff"
                  },
                },
              },
            },
          ],
        });
      }
    },
    /* 
      金额占比
    */
    drawPieTwoChart() {
      var myChartPie = this.$refs.chartPieTwo;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        chartPie.setOption({
          title: {
            text: "金额占比",
            subtext: "",
            x: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          color: this.serviceTotalColor,
          legend: {
            // orient: "vertical",
            // top:"bottom",
            bottom: 0,
            left: "center",
            data: this.serviceName,
          },
          series: [
            {
              name: "金额占比分析",
              type: "pie",
              radius: "80%",
              center: ["50%", "50%"],
              clickable: false, //是否开启点击
              minAngle: 20, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true, //是否启用防止标签重叠策略
              hoverAnimation: true, //是否开启 hover 在扇区上的放大动画效果。
              silent: false, //图形是否不响应和触发鼠标事件
              data: this.servicePrice, //数据源
              label: {
                normal: {
                  formatter: "{b}",
                  textStyle: {
                    fontSize: 12,
                    // color: "#fff"
                  },
                },
              },
            },
          ],
        });
      }
    },

    /* -----------------------商家管理的echarts图------------------------- */
    /* 
      数量占比
    */
    drawPieThreeChart() {
      var myChartPie = this.$refs.chartPieThree;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        chartPie.setOption({
          title: {
            text: "数量占比",
            subtext: "",
            x: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          color: this.merchantNumberColor,
          legend: {
            // orient: "vertical",
            // top:"bottom",
            bottom: 0,
            left: "center",
            data: this.merchantName,
          },
          series: [
            {
              name: "数量占比分析",
              type: "pie",
              radius: "80%",
              center: ["50%", "50%"],
              clickable: false, //是否开启点击
              minAngle: 20, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true, //是否启用防止标签重叠策略
              hoverAnimation: true, //是否开启 hover 在扇区上的放大动画效果。
              silent: false, //图形是否不响应和触发鼠标事件
              data: this.merchantNumber, //数据源
              label: {
                normal: {
                  formatter: "{b}",
                  textStyle: {
                    fontSize: 12,
                    // color: "#fff"
                  },
                },
              },
            },
          ],
        });
      }
    },

    /* 
      金额占比
    */
    drawPieFourChart() {
      var myChartPie = this.$refs.chartPieFour;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        chartPie.setOption({
          title: {
            text: "金额占比",
            subtext: "",
            x: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          color: this.merchantTotalColor,
          legend: {
            // orient: "vertical",
            // top:"bottom",
            bottom: 0,
            left: "center",
            data: this.merchantName,
          },
          series: [
            {
              name: "金额占比分析",
              type: "pie",
              radius: "80%",
              center: ["50%", "50%"],
              clickable: false, //是否开启点击
              minAngle: 20, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true, //是否启用防止标签重叠策略
              hoverAnimation: true, //是否开启 hover 在扇区上的放大动画效果。
              silent: false, //图形是否不响应和触发鼠标事件
              data: this.merchantPrice, //数据源
              label: {
                normal: {
                  formatter: "{b}",
                  textStyle: {
                    fontSize: 12,
                    // color: "#fff"
                  },
                },
              },
            },
          ],
        });
      }
    },

    /* 
      画图
    */
    drawCharts() {
      //用v-if或者v-show控制echarts图来显示和隐藏，必须要用this.$nextTick，因为dom可能没有生成
      this.$nextTick(() => {
        this.queryServiceItem();
        // this.queryAllMearchat();
      });
    },

    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
  },
  computed: {},
  components: {},
  created() {
    this.groupId = sessionStorage.getItem("groupId");
  },
  mounted() {
    this.drawCharts();
  },
};
</script>
<style lang="scss" scoped>
.evaluationreport {
  background: #fff;
  .evaluationreport-h3 {
    text-align: center;
    margin: 10px auto;
    font-weight: 700;
    color: rgb(59, 56, 56);
  }
  .ul-one {
    border: 1px solid #ccc;
    border-right: none;
  }
  .ul-two {
    border: 1px solid #ccc;
    border-top: none;
    border-right: none;
  }
  .evaluationreport-ul {
    color: rgb(70, 67, 67);
  }
  .evaluationreport-ul li {
    float: left;
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    list-style: none;
    box-sizing: border-box;
  }
  .ul-one li:nth-child(2n) {
    border-right: 1px solid #ccc;
  }
  .ul-one li:nth-child(2n + 1) {
    background: #bee1f4;
    border-right: 1px solid #ccc;
  }
  .ul-two li:nth-child(2n) {
    border-right: 1px solid #ccc;
  }
  .ul-two li:nth-child(2n + 1) {
    background: #bee1f4;
    border-right: 1px solid #ccc;
  }
  .ul-three {
    height: 100%;
    border: 1px solid #ccc;
    border-top: none;
    border-right: none;
  }
  .ul-three li {
    width: 50%;
    height: 100%;
    border-right: 1px solid #ccc;
  }
  ::deep .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0;
  }
  .table-second {
    height: 380px;
    overflow: auto;
  }
}
</style>